import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {Locale} from 'date-fns';
import React, {useEffect, useState} from 'react';
import {useIntl} from 'react-intl';

import DateUtils from 'src/js/common/utils/date_utils';
import {I18N_REDUCER_STATE_ID} from 'src/js/containers/i18n/i18n_constants';
import {useAppSelector} from 'src/js/store_hooks';

interface OwnProps {
  children: React.ReactNode;
}

type Props = OwnProps;

export const DlMuiDatePickerLocalizationProviderContainer: React.FC<Props> = (
  props
) => {
  const {children} = props;
  const intl = useIntl();
  const locale = DateUtils.translateLocaleToDateFnsLocale(intl.locale);
  const muiLocale = DateUtils.translateLocaleToMuiLocale(intl.locale);
  const i18nConfig = useAppSelector(
    (state) => state[I18N_REDUCER_STATE_ID].i18nConfig
  );
  const [localesData, setLocalesData] = useState<Record<string, Locale>>();
  const [localeXDatePickerTexts, setLocaleXDatePickerTexts] =
    useState<Record<string, any>>();

  useEffect(() => {
    if (i18nConfig) {
      const loadedLocalesData = DateUtils.loadLocaleData(i18nConfig);
      setLocalesData(loadedLocalesData);
      const loadedXDatePickersLocaleTexts =
        DateUtils.loadMuiXDatePickersLocaleText(i18nConfig);
      setLocaleXDatePickerTexts(loadedXDatePickersLocaleTexts);
    }
  }, [i18nConfig]);

  const dynamicProps = {
    // add adapterLocale prop only if localeData exists
    ...(localesData?.[locale] ? {adapterLocale: localesData[locale]} : {}),
    ...(localeXDatePickerTexts?.[muiLocale]
      ? {
          localeText:
            localeXDatePickerTexts[muiLocale][muiLocale].components
              .MuiLocalizationProvider.defaultProps.localeText,
        }
      : {}),
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} {...dynamicProps}>
      {children}
    </LocalizationProvider>
  );
};

DlMuiDatePickerLocalizationProviderContainer.displayName =
  'DlMuiDatePickerLocalizationProviderContainer';
